import React, { useEffect, useState } from "react";
import { NavFrame } from "./frames/navframe";
import SideFrame from "./frames/sideframe";
import SummaryTabWrap from "./tabs/summary/summarytabwrap";
import LabsWrap from "./tabs/labs/labsWrap";
import Procedures from "./tabs/procedure/procedure";
import PriorVisit from "./tabs/priorvisits/priorvisit";
import Vitals from "./tabs/vitals/vitals";
import RPM from "./tabs/rpm/rpm";
import Imaging from "./tabs/imaging/imaging";
import { Form } from "./tabs/forms/form";
import Document from "./tabs/Document/document";
import dayjs from "dayjs";
import CCmTable from "./tabs/ccm/ccm";
import api from "../../api/api";
import Refillstab from "../../orders/tabs/refills";
import ChatWrapper from "../../header/chat/chatwrapper";
import { eventBus } from "../../utils/eventBus";
import Threads from "./tabs/nonvisitnotes/threads";
import CareIQTab from "./tabs/careiq/CareIQTab";

const PateintsChartsWrapper = ({data ,dob,onClose,fetchpcarddata,setFetchedData, isloaderactive,fetchedData,searchdate}) => {
  const [currentTab, setCurrentTab] = useState(11);  // CareIQ is the default chart tab (Summary retired — matches care-sandbox)
  const [pendingResults, setPendingResults] = useState([]);
  const[internalnav,setInternaNav]=useState(false)
  const [vitalsinternav,setVitalsInternav]=useState(0)
  const[isreocrdingdisabled,setIsRecordingDisabled]=useState(false)
    const [hasRpmAccess, setHasRpmAccess] = useState(false);
    const practiseid = window.getPracticeId();
      const [chat,setChat]=useState(false)
const audiotabchange=()=>{
setInternaNav(1)
setCurrentTab(5)

}
const formatDate = (dateString) => {
  return dayjs(dateString).format("YYYY-MM-DD");
};

useEffect(() => {
  const handleNavigateToPriorVisit = (payload) => {
    if (payload?.tab !== undefined) {
      setCurrentTab(payload.tab);
    }
    if (payload?.internalTab !== undefined) {
      setInternaNav(payload.internalTab);
    }
  };

  eventBus.on("navigateToPriorVisit", handleNavigateToPriorVisit);

  return () => {
    eventBus.off("navigateToPriorVisit", handleNavigateToPriorVisit);
  };
}, []);
useEffect(() => {
  const handleNavigateTovitals= (payload) => {
    if (payload?.tab !== undefined) {
      setCurrentTab(payload.tab);
    }
    if (payload?.internalTab !== undefined) {
      setVitalsInternav(payload.internalTab);
    }
  };

  eventBus.on("navigateToPriorVitals", handleNavigateTovitals);

  return () => {
    eventBus.off("navigateToPriorVitals", handleNavigateTovitals);
  };
}, []);

// Listen for thread notification navigation
useEffect(() => {
  const handleNavigateToThreads = (payload) => {
    if (payload?.tab !== undefined) {
      setCurrentTab(payload.tab);
    }
  };

  eventBus.on("navigateToThreadsTab", handleNavigateToThreads);

  return () => {
    eventBus.off("navigateToThreadsTab", handleNavigateToThreads);
  };
}, []);

const fetchuserrpm=async()=>{
  try {
    const response=await api.get(`/v1/${practiseid}/patient/${data?.patientid}/rpm/get-rpm-patient`)
  
    if(response.status===200){
setHasRpmAccess(response?.rpm_status||false);
    }else{
      setHasRpmAccess(false);
    }
  } catch (error) {
    console.log(error)
  }
}
useEffect(()=>{
if(data?.patientid){
  fetchuserrpm()
}
},[data])

  const renderContent = () => {
          console.log(currentTab)
    switch (currentTab) {

      case 0:
        return <SummaryTabWrap isloaderactive={isloaderactive}dataId={data} setFetchedData={setFetchedData}
             fetchedData={fetchedData} searchdate={formatDate(data?.startdate)} />;
      case 1:
        return <LabsWrap dataId={data} />;
      case 2:
        return <Document dataId={data} searchdate={formatDate(data?.startdate)} />;
        case 3:
          return <Vitals vitalsinternav={vitalsinternav} setVitalsInternav={setVitalsInternav} dataId={data} setFetchedData={setFetchedData} />;
          case 4:
            return hasRpmAccess ? <RPM dataId={data} /> : null;
        case 5:
          return <PriorVisit internavtab={internalnav} dataId={data} searchdate={formatDate(data?.startdate)} />;
        
        case 6: 
        return <Imaging data={{ 
  ...data, 
  ...(dob && { dob }) 
}}

           />
           case 7:
            return <Form  
            data={data}
            searchdate={formatDate(data?.startdate)}
            />

            case 8:
              return <CCmTable setIsRecordingDisabled={setIsRecordingDisabled}  data={data}
            searchdate={formatDate(data?.startdate)}/>
            case 9:
              return <div className="max-h-[80vh] overflow-auto">


                  <Refillstab
                                    data={data}
                                    // setShowOrders={setShowOrders}
                                    // appointmentId={appointmentId}
                                    startDate={formatDate(data?.startdate)}
                                  />
              </div>

              case 10:
                return <div className="max-h-[75vh] overflow-auto">
<Threads  data={data} />

                </div> 
              case 11:
                return <CareIQTab dataId={data} onSwitchTab={setCurrentTab} setPendingResults={setPendingResults} />;
      default:
        return null;
    }
  };

  return (

<div className="lg:flex-row md:flex sm:flex-col flex-col w-full min-h-screen h-auto overflow-auto bg-[#f7f7f7]">

        <div className="w-full md:max-w-[20%]">
          <SideFrame
            onClose={onClose}
            setChat={setChat}
            fetchpcarddata={fetchpcarddata}
            currentTab={currentTab}
            isreocrdingdisabled={isreocrdingdisabled}
            data={data}
            audiotabchange={audiotabchange}
            setFetchedData={setFetchedData}
            fetchedData={fetchedData}
          />
        </div>
        <div className="flex-grow">
          <NavFrame
            activeTab={currentTab}
            onTabClick={(index) => setCurrentTab(index)}
              hasRpmAccess={hasRpmAccess}
          />
          <div className="p-4 h-[calc(100vh-60px)] overflow-hidden">
            {renderContent()}

          </div>
        </div>        {chat?<ChatWrapper setChat={setChat} patientdata={data} flow={'comment'} />:<></>}
      </div>
   
  );
};

export default PateintsChartsWrapper;
